import listReducer from '../common/list-reducer';
import pagingReducer from '../common/paging-reducer';
import listItemReducer from '../common/list-item-reducer';
import {getOrdersAction, getOrderAction} from "./actions";

const ordersReducer = listReducer.bind(getOrdersAction.getListReduceThisObj());
const ordersPagingReducer = pagingReducer.bind(getOrdersAction.getPagingReducerThisObj());
const orderInfoReducer = listItemReducer.bind(getOrderAction.getListReduceThisObj());

export default ({
    orders: ordersReducer,
    ordersPaging: ordersPagingReducer,
    orderInfos: orderInfoReducer
});